export default {"src":"/_next/static/media/radio-disabled-icon.90816d3e.svg","height":18,"width":18};